/* eslint-disable consistent-return */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, Layout, Text, ProgressBar } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { phoneSelector } from 'Store/modules/auth/selectors';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import { iconsPaths } from 'Constants/iconsPath';
import { useFetchPollingAnualDeclaration, useFetchPollingPreviousYears } from '../Loader/hooks';
import { DgEntertainmentProps, EntertainmentTypes } from './types';
import { entertraimentActions } from './utils';
import * as Styled from './styles';

const DgEntertainment = ({ type }: DgEntertainmentProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const isPreviousYears = useSelector(routeStateSelector);
  const phoneSaved = useSelector(phoneSelector);

  useFetchPollingPreviousYears(Boolean(isPreviousYears?.products?.isPreviousYear));
  useFetchPollingAnualDeclaration(!isPreviousYears?.products?.isPreviousYear);

  useEffect(() => {
    if (type === EntertainmentTypes.PRESENTATION) {
      const timer = setTimeout(() => {
        history.push(routes.DATAGATHERING_PROFILE, {
          products: isPreviousYears?.products,
        });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [type]);

  const handleClick = (): void => {
    if (type === EntertainmentTypes.PROFILE && !phoneSaved && entertraimentActions[type]) {
      entertraimentActions[type]?.onClick(isPreviousYears);
    } else {
      history.push(routes.DATAGATHERING_REFERRAL, {
        products: isPreviousYears?.products ?? {},
      });
    }
  };

  return (
    <OneColLayout>
      <Layout.Grid
        alignContent="center"
        alignItems="center"
        columns="repeat(1, 1fr)"
        gap="dimension_08"
        justifyContent="center"
        justifyItems="center"
      >
        <Styled.Container direction="column" align="center" justify="center" gap="dimension_16">
          <img src={iconsPaths.TAX} alt="taxito" />
          <Text type="headline" color="dark" align="center" size="XS_L_S">
            {t(entertraimentActions[type]?.title)}
          </Text>
          <Text type="paragraphs" color="dark" align="center" size="S_S_S">
            {t(entertraimentActions[type]?.subtitle)}
          </Text>
          {entertraimentActions[type]?.tinyButton && (
            <Buttons.Tiny
              label={t(entertraimentActions[type].tinyButton)}
              onClick={() => entertraimentActions[type].tinyButtonClick(isPreviousYears)}
            />
          )}
          {entertraimentActions[type]?.buttonLabel && (
            <Buttons.Classic
              label={t(entertraimentActions[type]?.buttonLabel)}
              size="m"
              mode="primary"
              onClick={() =>
                type === EntertainmentTypes.PROFILE
                  ? handleClick()
                  : entertraimentActions[type]?.onClick(isPreviousYears)
              }
            />
          )}
          {entertraimentActions[type]?.progress && (
            <Styled.ProgressContainer>
              <ProgressBar
                filled={entertraimentActions[type].progress}
                baseColor=""
                filledColor=""
              />
            </Styled.ProgressContainer>
          )}
        </Styled.Container>
      </Layout.Grid>
    </OneColLayout>
  );
};

export default DgEntertainment;
